import { SET_IS_LOADING, SET_TOKEN, SET_ERRORS, CLEAR_ERRORS } from './constants';

export const setIsLoading = isLoading => ({
  type: SET_IS_LOADING,
  payload: isLoading
});

export const setToken = payload => ({
  type: SET_TOKEN,
  payload
});

export const setErrors = errors => ({
  type: SET_ERRORS,
  errors
});

export const clearErrors = () => ({
  type: CLEAR_ERRORS
});